import { render, staticRenderFns } from "./ClienteList.vue?vue&type=template&id=4d19a932"
import script from "./ClienteList.vue?vue&type=script&lang=js"
export * from "./ClienteList.vue?vue&type=script&lang=js"
import style0 from "./ClienteList.vue?vue&type=style&index=0&id=4d19a932&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports